import React from "react";

export const BoxItem = () => {
  return <div> </div>;
};
